import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f049022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "batchimport" }
const _hoisted_2 = { class: "ant-upload-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "上传文件", -1))
const _hoisted_7 = { href: "https://gwtstatic1.blob.core.chinacloudapi.cn/tpl/batch_ordering_template_2.xlsx" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "点击下载", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"20px"} }, [
  /*#__PURE__*/_createTextVNode("点击上方文字按钮，下载模版，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("并按照规定格式填写数据")
], -1))
const _hoisted_10 = {
  key: 1,
  class: "resTips"
}
const _hoisted_11 = { style: {"padding":"0 10%"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、揽收地址信息：用于货物揽收，如未提前维护，将无法揽收", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、发件人信息：用于出口报关、进口清关及面单打印", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、批量上传模版的揽收地址信息及发件人信息都为客户设置的默认地址", -1))
const _hoisted_15 = {
  key: 2,
  class: "example"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cloud_upload_outlined = _resolveComponent("cloud-upload-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_cloud_download_outlined = _resolveComponent("cloud-download-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.list.length > 0)
      ? (_openBlock(), _createBlock(_component_a_form, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "上传文件:",
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_upload, {
                          "list-type": "picture-card",
                          "before-upload": _ctx.beforeUpload,
                          "show-upload-list": false,
                          customRequest: _ctx.handleUpload
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_2, [
                                _createTextVNode(" 上传文件格式仅支持.xs,"),
                                _hoisted_3,
                                _createTextVNode("且文件大小不得超过2M "),
                                _hoisted_4,
                                _hoisted_5,
                                _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                _hoisted_6
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["before-upload", "customRequest"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "模板下载:",
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("a", _hoisted_7, [
                            _createVNode(_component_cloud_download_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                            _hoisted_8
                          ]),
                          _hoisted_9
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "resTipsList"
            }, [
              _createElementVNode("p", null, "交易订单号：" + _toDisplayString(item.transactionNo), 1),
              _createElementVNode("p", null, "SKU编码：" + _toDisplayString(item.skuCode), 1),
              _createElementVNode("p", null, _toDisplayString(item.errMsg) + "," + _toDisplayString(item.processMsg), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [
          _hoisted_12,
          _hoisted_13,
          _hoisted_14
        ]),
        default: _withCtx(() => [
          _createTextVNode(" 温馨提示：请先维护地址管理页面的揽收地址信息及发件人信息。 "),
          _createVNode(_component_exclamation_circle_outlined, { style: {"color":"#30629C"} })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_row, {
      justify: "center",
      style: {"margin-top":"30px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (_ctx.list.length > 0)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.handleAddList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("继续上传订单信息")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}